import { render, staticRenderFns } from "./findBuddy.vue?vue&type=template&id=1ae9fc0a&"
import script from "./findBuddy.vue?vue&type=script&lang=js&"
export * from "./findBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports